<template>
  <router-view />
</template>

<script>
export default {
  name: 'reports-pages-container',
};
</script>
